module.exports = __webpack_public_path__ + "static/media/ELI_Logo.e3f4fe74.svg";